module.exports = __webpack_public_path__ + "img/CS-Hybrid_Ad-UC_1.01785661.jpg";